import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import unlockService from '../services/unlockService';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_live_51SHEVP2Y8TDovOpusSSoLWA65y4dwsrWFQDYB0mHbdwepJS94KGyDPnKrXjnOlZTtbfqo0Q8Kv0KOEMxuDQ0KGIv00NjBtWwf0');

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontSize: '16px',
      color: '#264653',
      '::placeholder': { color: '#aab7c4' },
    },
    invalid: {
      color: '#9e2146',
    },
  },
};

function AddCardForm({ onSuccess, onCancel }) {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;
    setLoading(true);
    setError(null);
    try {
      const { clientSecret } = await unlockService.createSetupIntent({ purpose: 'billing_profile' });
      const { error: stripeError } = await stripe.confirmCardSetup(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
          billing_details: { name: 'Billing' },
        },
      });
      if (stripeError) {
        setError(stripeError.message);
      } else {
        onSuccess();
      }
    } catch (err) {
      console.error('SetupIntent error:', err);
      setError(err.message || 'Failed to add card. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label className="d-block mb-2">Card details</label>
        <div className="p-2 border rounded" style={{ background: '#fff' }}>
          <CardElement options={CARD_ELEMENT_OPTIONS} />
        </div>
      </div>
      {error && <div className="small text-danger mb-2">{error}</div>}
      <div className="d-flex justify-content-end gap-2 mt-3">
        <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={loading}>
          Cancel
        </button>
        <button type="submit" className="btn btn-info" disabled={loading}>
          {loading ? 'Adding…' : 'Add card'}
        </button>
      </div>
    </form>
  );
}

export default function BillingAddCardModal({ isOpen, onClose, onSuccess }) {
  if (!isOpen) return null;
  const handleSuccess = () => {
    onSuccess?.();
    onClose();
  };
  return (
    <div className="modal d-block" style={{ background: 'rgba(0,0,0,0.5)' }} onClick={onClose}>
      <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add payment method</h5>
            <button type="button" className="close" onClick={onClose} aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Elements stripe={stripePromise}>
              <AddCardForm onSuccess={handleSuccess} onCancel={onClose} />
            </Elements>
          </div>
        </div>
      </div>
    </div>
  );
}
